import { PlusIcon } from '@phosphor-icons/react';
import { useState } from 'react';

import { BaseButton, ButtonSize } from '../../../components/button/BaseButton';
import { useTranslation } from '../../../contexts/translation-context';
import { OrderDocumentType } from 'src/types/enums';
import { CarrierDocumentUploadDialog } from './CarrierDocumentUploadDialog';

interface CarrierCmrUploaderButtonProps {
  carrierId: number;
  orderId: string;
  /** Which required document is being uploaded. Defaults to CMR. */
  type?: OrderDocumentType;
  /** Override the trigger button label (defaults to "Documents"). */
  buttonLabel?: string;
  size?: ButtonSize;
  disableUpload?: boolean;
  onUploaded: (type: OrderDocumentType) => Promise<void>;
}

/** Single-type upload button. Use CarrierPortalDocsSplitButton when the order
 *  requires more than one document type. */
export const CarrierCmrUploaderButton: React.FC<CarrierCmrUploaderButtonProps> = ({
  carrierId,
  orderId,
  type = OrderDocumentType.Cmr,
  buttonLabel,
  size,
  disableUpload,
  onUploaded,
}) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <BaseButton
        color="secondary"
        size={size}
        iconLeft={<PlusIcon className="button-icon" />}
        disabled={disableUpload}
        onClick={() => setOpen(true)}
      >
        {buttonLabel ?? i18n('carrierPortal.orders.documents')}
      </BaseButton>

      <CarrierDocumentUploadDialog
        carrierId={carrierId}
        orderId={orderId}
        types={open ? [type] : null}
        onClose={() => setOpen(false)}
        onUploaded={onUploaded}
      />
    </>
  );
};
